import repository from "@/repository/admin/index.js"

export default {
    async getPatientInfo({rootState, commit}) {
        const patient_id = rootState.adminDashboardMenuStore.patient_id;
        const {data} = await repository.getPatientInfo({patient_id})
        commit('SET_PATIENT_DATA', data);
    }
}
